// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__1DGJE","navText":"Navbar_navText__1HLkX","navLogo":"Navbar_navLogo__3XkCa","imgLogo":"Navbar_imgLogo__1g1AG"};